module.exports = __webpack_public_path__ + "img/6.514b6d4e.jpg";